export default __webpack_public_path__ + "static/media/moon.90150abb.svg";